export default __webpack_public_path__ + "static/media/la_capelle6.577bd731.jpg";